<template>
    <div class="c-toggle-view">
        <slot></slot>
    </div>
</template>

<script>
import {gsap, Power3} from 'gsap/all';

export default {
  data() {
    return {
        isOpen: false,
    }
  },
  mounted() {
    this.$el.querySelectorAll('.btn-toggle').forEach((btn) => {
      btn.addEventListener('click', this.toggle);
    });
    window.addEventListener('resize', this.resize);
  },
  methods: {
    toggle(e) {
      e.preventDefault();
      if (this.isOpen) {
        this.isOpen = false;
        this.close();
      } else {
        this.isOpen = true;
        this.open();
      }
    },
    open() {
        const height = this.$el.querySelector('.c-toggle-view__interview__content').getBoundingClientRect().height;
        const wrapper = this.$el.querySelector('.c-toggle-view__interview');
        gsap.killTweensOf(wrapper);
        gsap.to(wrapper, {
            duration: 1,
            height: height,
            ease: Power3.easeInOut,
        });
    },
    close() {
        const wrapper = this.$el.querySelector('.c-toggle-view__interview');
        gsap.killTweensOf(wrapper);
        gsap.to(wrapper, {
            duration: 1,
            height: 0,
            ease: Power3.easeOut,
        });
    },
    resize() {
        if (this.isOpen) {
            const height = this.$el.querySelector('.c-toggle-view__interview__content').getBoundingClientRect().height;
            const wrapper = this.$el.querySelector('.c-toggle-view__interview');
            gsap.killTweensOf(wrapper);
            gsap.set(wrapper, {
                height: height,
            });
        }
    }
  }
}

</script>